import { _ } from "libs";

import React, { FC, useState, useEffect } from "react";
import ClubPage from "./club";
import { RouteChildrenProps } from "react-router";
import Modal from "../components/modal";
import { SimpleLoginBox } from "./login";
import { loggedIn, forceLogout, loadClub, setFederationUserId } from "../actions";
import NavbarWidget from "../components/navbarWidget";
import { RootState } from "../reducers";
import withRedux from "../withRedux";
import { Club, Connected } from "../types";
import Loader from "../components/loader";
import { SimpleRegisterBox } from "./register";
import { parseHashArray } from "../libs/parseHashArray";
import { AuthState } from "../reducers/auth";

interface Props {
	loadClub: Connected<typeof loadClub>;
	setFederationUserId: Connected<typeof setFederationUserId>;
	auth: AuthState;
}

const ClubWidgetPage: FC<RouteChildrenProps<any> & Props> = (props: RouteChildrenProps<any> & Props) => {
	const [showModal, setShowModal] = useState(false);
	const [showRegistrationModal, setShowRegistrationModal] = useState(false);
	const [club, setClub] = useState(null as Club);

	const isSwissTennisVersion = props.location.pathname.split("/")[3] === "swisstennis-widget";
	const isCityOfZurichVersion = props.location.pathname.split("/")[3] === "stadt-zurich-widget";

	const search = props.location.search;
	const federationUserId = new URLSearchParams(search).get("federationUserId");

	const { clubIds } = parseHashArray(props.location.hash);

	const canGoBack = clubIds && clubIds.length > 1;

	const openModal = () => {
		setShowModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
	};

	const openRegistrationModal = () => {
		setShowRegistrationModal(true);
	};

	const closeRegistrationModal = () => {
		setShowRegistrationModal(false);
	};

	const logout = () => {
		setShowModal(false);
		forceLogout(props.match.url);
	};

	useEffect(() => {
		props.setFederationUserId(federationUserId);
	}, [federationUserId]);

	useEffect(() => {
		const {
			match: { params },
		} = props;

		const { uuid } = params;

		if (isSwissTennisVersion) {
			document.body.dataset.branded = "swisstennis";
		}

		if (isCityOfZurichVersion) {
			document.body.dataset.branded = "stadt-zurich";
		}

		props.loadClub(uuid).then(setClub);
	}, [props.match.params]);

	if (!club) {
		return <Loader />;
	}

	if (!club && true !== props.auth?.tokenRefreshing) {
		return <Loader />;
	}

	return (
		<div id="app" data-page="standalone">
			<NavbarWidget
				authenticated={loggedIn()}
				clubName={club.clubInfo.name}
				hash={props.location.hash || ""}
				canGoBack={canGoBack}
				onLoginButtonClicked={openModal}
				onRegisterButtonClicked={openRegistrationModal}
			/>
			<ClubPage
				{...props}
				widgetMode={true}
				onLogoutButtonClicked={logout}
				onLoginButtonClicked={openModal}
				preloadedClub={club}
			/>
			{showModal && !loggedIn() ? (
				<Modal title={_("loginPage.heading")} onCloseClicked={closeModal}>
					<SimpleLoginBox destination={props.match.url + props.location.search} />
				</Modal>
			) : null}

			{showRegistrationModal && !loggedIn() ? (
				<Modal title={_("registerPage.heading")} onCloseClicked={closeRegistrationModal}>
					<SimpleRegisterBox destination={props.match.url + props.location.search} />
				</Modal>
			) : null}
		</div>
	);
};

const mapStateToProps = ({ auth, reservation, social: { friends } }: RootState, ownProps) => {
	return { auth, reservation, friends };
};

export default withRedux(
	{
		loadClub,
		setFederationUserId,
	},
	mapStateToProps
)(ClubWidgetPage);
